import { Modal, MenuItem, Select, TextField } from '@mui/material'
import { Dispatch, SetStateAction, useState } from 'react';
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/material";

interface ModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

export function UpgradeDowngradeModal({ open, onClose, setOpen }: ModalProps) {
  const [plan, setPlan] = useState('default');
  const [Cycle, setCycle] = useState('default');
  return (
    <Modal className="modal upgradeDowngrade_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title">
            <h2>Upgrade / Downgrade Plan</h2>
            <div className="btn-close" onClick={() => setOpen(false)}>
              <CloseIcon />
            </div>
          </div>

          <form className="form">
            <div className="control_group">
              <label>New Plan</label>
              <Select value={plan} onChange={(e) => setPlan(e.target.value)} fullWidth>
                <MenuItem value="default">Select New Plan</MenuItem>
                <MenuItem value="basic">Basic Plan</MenuItem>
                <MenuItem value="premium">Premium Plan</MenuItem>
              </Select>
            </div>
            <div className="control_group">
              <label>Billing Cycle</label>
              <Select value={Cycle} onChange={(e) => setCycle(e.target.value)} fullWidth>
                <MenuItem value="default">Select Billing Cycle</MenuItem>
                <MenuItem value="Monthly">Monthly</MenuItem>
                <MenuItem value="Yearly">Yearly</MenuItem>
              </Select>
            </div>
            <div className="control_group">
              <label>Price</label>
              <TextField fullWidth hiddenLabel value="AED 199" disabled />
            </div>

            <div className="footer_btn_flex">
              <Button className="btn btn_grey" onClick={() => setOpen(false)}>Cancel</Button>
              <Button className="btn btn_primary" onClick={() => setOpen(false)}>Confirm</Button>
            </div>
          </form>
        </div>
      </div>
    </Modal>
  )
}